import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { ResetArtistStore } from '../../artist/action-creators';
import { ResetReleaseStore } from '../../release/action-creators';
import { ResetInvitesStore } from '../../invites/action-creators';
import {
  ResetCatalogStore,
  ResetArtistCatalogStore,
} from '../../catalog/action-creators';
import { ResetUserStore } from '../../user/action-creators';
import { ResetDealsState } from '../../deals/action-creators';

export const resetAfterLogoutEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, actionCreators.LogoutUserSuccess>(
      actions.LOGOUT_USER_SUCCESS
    ),
    concatMap(() => [
      new ResetArtistStore(),
      new ResetReleaseStore(),
      new ResetInvitesStore(),
      new ResetUserStore(),
      new ResetCatalogStore(),
      new ResetArtistCatalogStore(),
      new ResetDealsState(),
    ])
  );
